import { useHotelSlot } from "@b2bportal/core-hotels";
import { useHotelsStyles, useModuleBEM } from "@b2bportal/core-themes";
import { CoreHotelsComponent } from "@b2bportal/core-types";
import { Loading, Page } from "@b2bportal/core-ui";
import clsx from "clsx";
import defaultStyles from "./RoomSelectionPage.module.scss";
import type { RoomSelectionPageProps } from "./types";

const COMPONENT_KEY = CoreHotelsComponent.RoomSelectionPage;

export const RoomSelectionPage = ({
  context,
  text,
  handlers,
}: RoomSelectionPageProps) => {
  const styles = useHotelsStyles(COMPONENT_KEY, defaultStyles);
  const [block, cn] = useModuleBEM(styles, COMPONENT_KEY);

  const HotelSlot = useHotelSlot();

  //TODO: handle error
  if (context.isError) {
    return <div></div>;
  }

  return (
    <Page
      className={clsx(block, { [cn("page-loading")]: context.isLoading })}
      title={text.title}
    >
      {context.isLoading ? (
        <div className={cn("loading")}>
          <Loading />
        </div>
      ) : (
        <div className={cn("content")}>
          <HotelSlot.HotelRoomSelection goToNextStep={handlers.goToNextStep} />
        </div>
      )}
    </Page>
  );
};
